<button class="raster-item" (click)="mapItemClicked.emit(mapItem)">
    <div uiPopupContentHost></div>
</button>
